import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
import CustomFormInput from '../../../../commonComponents/CustomFormInput';
import BigSubmitButton from '../../../../commonComponents/BigSubmitButton';
import useComponentForm from './hooks/useComponentForm';
import { useTranslation } from 'react-i18next';
import YesNoInput from '../../../../YesNoInput';
import { Link } from 'react-router-dom';
import CustomDateInput from '../../../../CustomDateInput';

const Form = () => {
  const { t } = useTranslation();
  const { control, handleSubmit, onSubmit, isLoading, isSuccess } = useComponentForm();
  return (
    <Box
      display="flex"
      width="100%"
      flexDirection="column"
      justifyContent="space-evenly"
      alignItems="center"
      gap="20px"
      marginY="24px"
    >
      <CustomFormInput name="zip" control={control} label={t('YZip')} inputProps={{ inputMode: 'numeric' }} />
      <CustomFormInput name="address" control={control} label={t('YAddress')} />

      <CustomDateInput name="birthdate" control={control} label={t('YBirthdate')} />

      <YesNoInput question={t('what_is_your_status')} control={control} name="married" />
      <YesNoInput question={t('do_you_have_house')} control={control} name="estate" />
      <BigSubmitButton
        onClick={handleSubmit(onSubmit)}
        buttonText={t('Submit')}
        color="inherit"
        disabled={isSuccess && !isLoading}
      />
      {isSuccess && !isLoading && (
        <>
          <Alert severity="success">{t('form_submited_successfuly')}</Alert>
          <Typography variant="body2">
            {t('check_out_our_site')}: <Link to="/">digitalesbuero.ch</Link>{' '}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default Form;
